// Thin wrapper around localStorage — safe for SSR/no-window contexts.

const hasWindow = () => typeof window !== "undefined" && !!window.localStorage;

export const storage = {
  get(key, fallback = null) {
    if (!hasWindow()) return fallback;
    try {
      const raw = window.localStorage.getItem(key);
      if (raw === null) return fallback;
      try {
        return JSON.parse(raw);
      } catch {
        return raw;
      }
    } catch {
      return fallback;
    }
  },

  set(key, value) {
    if (!hasWindow()) return;
    try {
      const serialized = typeof value === "string" ? value : JSON.stringify(value);
      window.localStorage.setItem(key, serialized);
    } catch {
      /* ignore quota / serialization errors */
    }
  },

  remove(key) {
    if (!hasWindow()) return;
    window.localStorage.removeItem(key);
  },

  clear() {
    if (!hasWindow()) return;
    window.localStorage.clear();
  },
};

export const STORAGE_KEYS = {
  TOKEN: "irbansus:token",
  USER: "irbansus:user",
};
